import React, {useState, useEffect} from 'react';
import {Button, Layout, Menu} from 'antd';
import {LogoutOutlined} from '@ant-design/icons';
import {Outlet, useNavigate, useLocation} from 'react-router-dom';

const {Header, Content} = Layout;

const DashboardLayout: React.FC = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [selectedKey, setSelectedKey] = useState('manage-cases');

    // 根据当前路径设置选中的菜单项
    useEffect(() => {
        const path = location.pathname.split('/')[1];
        setSelectedKey(path);
    }, [location]);

    const handleMenuClick = (key: string) => {
        setSelectedKey(key);
        navigate(`/${key}`);
    };

    const handleLogout = async () => {
        localStorage.removeItem('adminUser');
        navigate('/login');
    };

    return (
        <Layout className="min-h-screen bg-gray-50">
            <Header className="flex items-center justify-between px-4 bg-white shadow-sm">
                <div className="flex-1">
                    <Menu
                        mode="horizontal"
                        selectedKeys={[selectedKey]}
                        className="border-none"
                        items={[
                            {
                                key: 'manage-cases',
                                label: 'Cases Management',
                                className: 'hover:text-blue-500 transition-colors'
                            },
                            {
                                key: 'sales-contact',
                                label: 'Sales Contact',
                                className: 'hover:text-blue-500 transition-colors'
                            },
                            {
                                key: 'change-password',
                                label: 'Change Password',
                                className: 'hover:text-blue-500 transition-colors'
                            }
                        ]}
                        onClick={({key}) => handleMenuClick(key)}
                    />
                </div>
                <Button
                    type="text"
                    icon={<LogoutOutlined/>}
                    onClick={handleLogout}
                    className="hover:bg-gray-100 hover:text-blue-500 transition-colors ml-4"
                >
                    Logout
                </Button>
            </Header>
            <Content className="p-6 m-4 bg-white rounded-lg shadow-sm">
                <Outlet/>
            </Content>
        </Layout>
    );
};

export default DashboardLayout;
